import styled from 'styled-components';

export const StyledInformation = styled.div`
  width: 100%;
  padding: 12px 0;
  border-top: 1px solid #dbdce6;
  border-bottom: 1px solid #dbdce6;
`;
